/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import '../../../behaviors/app-menu-access-behaviour.js';
import '../behaviors/keyboard-accessibility.js';

const template = html`
		<style include="app-styles">
            .border-round-brand-color{
              border:1px solid var(--brand-color);
                border-radius :24px;
            }
            .padding-4px{
                padding: 4px;
            }
            /*Sandeep Changes Starts*/
            @media only screen and (min-device-width : 320px) and (max-device-width : 767px){
                .text-brand-color{
                    color:var(--primary-light-color) !important;
                }
                .secondary-dark-text-l,.secondary-dark-text-xxl,.secondary-dark-text-s{
                    color:var(--primary-light-color);
                }
                .border-round-brand-color{
                  border:1px solid var(--primary-light-color);
                }
              }  
            
            /*Sandeep Changes ends*/
		</style>
        
        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>
        <div class$="{{_addClassBasedOnDevice(desktop)}}">
            <div tabindex="0" on-tap="_navigateToInvestment" on-keydown="_navigateToInvestmentDDA" class="outlineOffset">
            <div hidden$="{{!desktop}}" class="text-transform-uppercase disabled-dark-color font-size-s">
                <oe-i18n-msg msgid="h_Investment"></oe-i18n-msg>
                <div class="padding-4px"></div>
            </div>
            <template is="dom-if" if="{{investmentLoader}}">
                <paper-spinner id="dashboard_user_investment_spinner" active></paper-spinner>
            </template>
            <template is="dom-if" if="{{!investmentLoader}}">
                <template is="dom-if" if="{{!isMenuId}}">
                    <div hidden$={{!investmentsAvailable}}>
                        <template is="dom-repeat" items="{{investmentsAmountList}}">
                            <div id="dashboard_user_investment_amount_{{index}}">
                                <div class="outlineOffset secondary-dark-text-xxl font-weight-bold cursor-pointer" on-tap="_navigateToInvestment" hidden$={{desktop}} tabindex="0">
                                <currency-formator format-value={{item.amount}}></currency-formator>
                                </div>
                                <div class="outlineOffset secondary-dark-text-l font-weight-bold cursor-pointer" on-tap="_navigateToInvestment" hidden$={{!desktop}} tabindex="0">
                                <currency-formator format-value={{item.amount}} tooltipnotrequired={{!item.showTooltip}} formatting-amount=true></currency-formator>
                                </div>
                            </div>
                        </template>
                        <div class="secondary-dark-text-s" hidden$={{desktop}}>
                            <oe-i18n-msg msgid="m_DashboardMessage2"></oe-i18n-msg>
                        </div>
                        <div class="secondary-dark-text-xs" hidden$={{!desktop}}>
                            <oe-i18n-msg msgid="m_DashboardMessage2"></oe-i18n-msg>
                        </div>
                    </div>
                    <div hidden$={{investmentsAvailable}}>
                        <div hidden$={{desktop}}>
                        <!--Sandeep changes-->
                            <div hidden$={{tablet}}>
                              <div class="secondary-dark-text-xxl font-weight-bold">
                                  {{investmentsSuggestions.number}}
                              </div>
                              <div class="secondary-dark-text-s">
                                  {{investmentsSuggestions.text}}
                              </div>
                              <div class="mdl-grid">
                                  <div class="mdl-cell mdl-cell--12-col content-align-center">
                                  <template is="dom-if" if={{!prospectIndicatorFlag}}>
                                  <div class="border-round-brand-color mdl-grid padding-t-zero padding-b-zero text-brand-color">
                                      <paper-button on-tap="createAccountDIB"><oe-i18n-msg msgid="b_apply"></oe-i18n-msg></paper-button>
                                      </div>
                                  </template>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div hidden$={{!desktop}}>
                            <div class="secondary-dark-text-l font-weight-bold">
                                {{investmentsSuggestions.number}}
                            </div>
                            <div class="secondary-dark-text-xs">
                                {{investmentsSuggestions.text}}
                            </div>
                            <div>
                                <template is="dom-if" if={{!prospectIndicatorFlag}}>
                                <div class="padding-4px padding-l-zero">
                                <paper-button class="margin-zero border-round-brand-color padding-4px text-brand-color font-size-s"  on-tap="createAccountDIB"><oe-i18n-msg msgid="b_apply"></oe-i18n-msg></paper-button>
                                </div>
                                </template>                            
                            </div>
                        </div>
                    </div>
                </template>
                <template is="dom-if" if="{{isMenuId}}">
                    <oe-i18n-msg class="font-size-m" msgid="l_PermissionErrorMessage"></oe-i18n-msg>
                </template>
            </template>
            </div>
        </div>`;
Polymer({
  is: 'dashboard-user-investment',
  behaviors: [corpBehaviours.appMenuBehaviour, accessibilityBehaviours.commonFunctions, sbBehaviours.retailDashboardBehavior],
  _template: template,
  properties: {
    investments: {
      type: Array,
      notify: true,
      observer: '_investmentsListChanged'
    },
    investmentLoader: {
      type: Boolean,
      value: true,
      notify: true
    },
    investmentAccountSchemes: {
      type: Array,
      value: ['TDA', 'TUA']
    },
    investmentsAmountList: {
      type: Array,
      notify: true
    },
    investmentsAvailable: {
      type: Boolean,
      value: true,
      notify: true
    },
    investmentsSuggestions: {
      type: Object,
      notify: true
    },
    prospectIndicatorFlag: {
      type: Object,
      computed: 'computeProspectIndicator()'
    },
    menuId: {
      type: String,
      notify: true,
      value: "ORINV"
    },
    isMenuId: {
      type: Boolean,
      notify: true
    },

    /*getting list of bonds*/
    bonds: {
      type: Array,
      notify: true,
      observer: 'handleBonds'
    },

    /*getting sum of bonds*/
    totalBonds: {
      type: String,
      notify: true
    }
  },

  /*Observer for summing up the bonds amount*/
  handleBonds: function () {
    var temp = this.bonds;
    this.set('totalBonds', temp.map(item => item.marketValue.amount).reduce((a, b) => a + b));
  },
  attached: function () {
    this.set('isMenuId', this.validateElement(this.menuId));
  },
  computeProspectIndicator: function () {
    return clientStorage.get(storageType.session, "prospectIndicator") == "Y";
  },
  _addClassBasedOnDevice: function (desktop) {
    if (desktop) return "";
    return "text-align-center";
  },
  _goToSuggestion: function () {
    var url = this.investmentsSuggestions.url;
    window.oe_navigate_to(url, "");
  },
  _navigateToInvestment: function () {
    if (this.isMenuId) return;

    var self = this;
    var detailsURL = "/depositAcctLanding";

    var detailsNavigationData = {
      'investmentAccountList': this.investments,
      'investmentsAmountList': this.investmentsAmountList
    };

    this.getDataForIds(this.investments, "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/depositaccounts", function (list) {
      detailsNavigationData = {
        'investmentAccountList': list,
        'investmentsAmountList': self.investmentsAmountList
      };
      window.oe_navigate_to(detailsURL, detailsNavigationData);
    });
  },
  _investmentsListChanged: function () {
    var currencyValueList = [];
    var currencyValueMap = {};
    var investmentsAmountList = [];
    var pageTitle = document.getElementById('page-title-label');

    if (this.investments) {
      if (this.investments.length > 0) {
        if (this.bonds) {
          for (let i = 0; i < this.bonds.length; i++) {
            if (currencyValueMap[this.bonds[i].bondCurrency] != undefined) {
              let temp = currencyValueMap[this.bonds[i].bondCurrency];
              currencyValueList[temp] = Number(currencyValueList[temp]) + Number(this.bonds[i].marketValue.amount);
            } else {
              currencyValueList.push(Number(this.bonds[i].marketValue.amount));
              currencyValueMap[this.bonds[i].bondCurrency] = currencyValueList.length - 1;
            }
          }
        }
        for (var i = 0; i < this.investments.length; i++) {
          if (this.investmentAccountSchemes.indexOf(this.investments[i].accountType.cmCode) > -1) {
            var account = this.investments[i];
            for (var j = 0; j < account.balances.length; j++) {
              if (account.balances[j].type == "clearBalance") {
                if (currencyValueMap[account.balances[j].amountDetails.currency] != undefined) {
                  var temp = currencyValueMap[account.balances[j].amountDetails.currency];
                  currencyValueList[temp] = Number(currencyValueList[temp]) + Number(account.balances[j].amountDetails.amount);
                }
                else {
                  currencyValueList.push(Number(account.balances[j].amountDetails.amount));
                  currencyValueMap[account.balances[j].amountDetails.currency] = currencyValueList.length - 1;
                }
              }
            }
          }
        }

        for (var key in currencyValueMap) {
          var index = currencyValueMap[key];
          var val = currency.symbolize(key + ' ' + Number(currencyValueList[index]));
          var amountValue = val.slice(2, val.length);
          amountValue = amountValue[amountValue.length - 3] == "." ? amountValue.slice(0, amountValue.length - 3) : amountValue;
          var showTooltip = amountValue.length >= 4 ? true : false;
          investmentsAmountList.push({ "amount": val, "showTooltip": showTooltip });
        }

        this.investmentsAmountList = investmentsAmountList;
        if (this.$$("#dashboard_user_investment_spinner") != null)
          this.$$("#dashboard_user_investment_spinner").active = false;
        this.investmentLoader = false;
      } else if (pageTitle.appData.investmentsSuggestionsCallDone === undefined) {
        var self = this;
        this.investmentsAvailable = false;
        pageTitle.appData.investmentsSuggestionsCallDone = true;

        if (this.prospectIndicatorFlag) {
          if (this.$$("#dashboard_user_investment_spinner") != null)
            this.$$("#dashboard_user_investment_spinner").active = false;
          this.investmentLoader = false;
          this.set('investmentsSuggestions', {});
          pageTitle.appData.investmentsSuggestions = this.investmentsSuggestions;
          return;
        }

        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/accountSuggestions/investments";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function (event) {
          if (event.detail.response != null) {
            var suggestions = event.detail.response.accountSuggestion;
            self.set('investmentsSuggestions', suggestions);
            pageTitle.appData.investmentsSuggestions = self.investmentsSuggestions;
          }

          if (self.$$("#dashboard_user_investment_spinner") != null)
            self.$$("#dashboard_user_investment_spinner").active = false;
          self.investmentLoader = false;
        });
        ajaxCall.addEventListener("error", function (e) {
          self.serviceError(e);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
      } else {
        if (this.$$("#dashboard_user_investment_spinner") != null)
          this.$$("#dashboard_user_investment_spinner").active = false;
        this.investmentLoader = false;
        this.investmentsAvailable = false;
        if (pageTitle.appData.investmentsSuggestions) this.set('investmentsSuggestions', pageTitle.appData.investmentsSuggestions);
      }
    }
  },
  serviceError: function () {
    // this.fire("oe-show-error","Please try after sometime. Currently we are not able to process your request due to technicle issues");
    if (this.$$("#dashboard_user_investment_spinner") != null)
      this.$$("#dashboard_user_investment_spinner").active = false;
    this.investmentLoader = false;
    this.set('investmentsSuggestions', {}); //TODO
    // log clientside issues 
  },
  createAccountDIB: function () {
    var isExistingCustomer = "Y";
    var existingCustomerInfo = {};
	var self = this;
    existingCustomerInfo.isExistingCustomer = isExistingCustomer;
    //existingCustomerInfo.selectedProductCategories = ["TermDeposit"];
    // Replacing the hardcoded values by fetching it from API call as part of feature 301794
    var ajaxCall = document.createElement('oe-ajax');
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=7";
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      let response = event.detail.response;
      existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function (prod) { return prod.productCategoryId.codeDescription });
      window.oe_navigate_to("/directbanking", {
        "existingCustomerInfo": existingCustomerInfo
      });
    });
    ajaxCall.addEventListener("error", function (e) {
      existingCustomerInfo.selectedProductCategories = [];
      var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
      self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
    });
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
  },

  _navigateToInvestmentDDA(keyboardEvent) {
    if (keyboardEvent.code === "Enter" || keyboardEvent.which === 13 || keyboardEvent.keyCode === 13) {
      this._navigateToInvestment(keyboardEvent);
    }
  },
  /*Get list for bonds holdings*/
  _getAjaxBondServiceCall: function (urlForId) {
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + urlForId;
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      self.bonds = event.detail.response;
    });
    ajaxCall.addEventListener("error", function (e) {
      self.serviceError(e, urlForId);
    });
    ajaxCall.generateRequest();
  }

});
